export const COLORS = [
	"red",
	"rose",
	"ember-blaze",
	"orange",
	"salmon",
	"amber",
	"yellow",
	"lime",
	"green",
	"fern",
	"emerald",
	"jade",
	"teal",
	"cyan",
	"azure",
	"sky",
	"blue",
	"indigo",
	"violet",
	"purple",
	"accent",
	"slate",
	"zinc",
	"gray",
	"stone",
	"primary",
] as const;

export type Color = (typeof COLORS)[number];
